<div class="row">
    <div class="col-sm-6">
        <h4>Lista de opciones de la pregunta</h4>
    </div>
    <div class="col-sm-6 text-end">
        <a [routerLink]="['../../add', idquestionSelected]" class="btn-add">
            <i class="fa fa-plus px-2"></i> Agregar nueva opcion
        </a>
    </div>
    <div class="col-md-12">
        <table class="table table-hover">
            <thead class="thead-detail text-center">
                <tr class=" table-success">
                    <th scope="col">N°</th>
                    <th scope="col">Título</th>
                    <th scope="col">Orden</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Ejes</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let o of svoption; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ o.label }}</td>
                    <td class="text-center">{{ o.order }}</td>
                    <td class="text-center">
                        <div class="label-active" *ngIf="o.isActive">ACTIVO</div>
                        <div class="label-inactive" *ngIf="!o.isActive">INACTIVO</div>
                    </td>
                    <ng-container *ngIf="o.isMatrix">
                        <td>
                            <a class="btn-add" [routerLink]="['/encuesta/encuestas/seccion/question/option/axis/list',o.id]"
                                title="Editar lista de ejes">
                                <i class="fa fa-list-ol px-2"></i>
                            </a>
                        </td>
                    </ng-container>
                    <td class="text-center"><a class="a-icon text-center"
                            [routerLink]="['/encuesta/encuestas/seccion/question/option/edit', o.id]"><i
                                class="fa fa-pencil i-icon"></i></a>
                    </td>
                    <td class="text-center"><a class="a-icon text-center"
                            [routerLink]="['/encuesta/encuestas/seccion/question/option/list', idquestionSelected]"
                            (click)="remove(o.id)"><i class="fa fa-trash i-icon"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>
    <ng-container *ngIf="!hiddenMsg">
        <app-alert [message]="msg.message" [status]="msg.status"></app-alert>
    </ng-container>
</div>